export default __webpack_public_path__ + "static/media/FB.6cc13bf7.svg";